export default {
  "content": "<g clip-path=\"url(#clip0_30_1346)\" fill=\"#7B61FF\"><path d=\"M18.009 8.81l-6.5 7.5a1.001 1.001 0 01-1.509.004l-3.5-4 1.506-1.317 2.743 3.135L16.497 7.5l1.512 1.31z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.515 3.515c4.686-4.687 12.284-4.687 16.97 0 4.687 4.686 4.687 12.284 0 16.97-4.686 4.687-12.284 4.687-16.97 0-4.687-4.686-4.687-12.284 0-16.97zM19.07 4.929c-3.905-3.905-10.237-3.905-14.142 0-3.905 3.905-3.905 10.237 0 14.142 3.905 3.905 10.237 3.905 14.142 0 3.905-3.905 3.905-10.237 0-14.142z\"/></g><defs><clipPath id=\"clip0_30_1346\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};